var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDashboardClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C7 11.8954 7.89543 11 9 11H45C46.1046 11 47 11.8954 47 13V38H7V13Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15625 14C9.15625 13.4477 9.60397 13 10.1562 13H44.1563C44.7085 13 45.1563 13.4477 45.1563 14V36H9.15625V14Z",
    fill: "url(#paint0_linear_974_10221)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13636 38.0527H46.8636L50 40.0527H4L7.13636 38.0527Z",
    fill: "url(#paint1_linear_974_10221)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 40.105H50V42.105C50 42.6573 49.5523 43.105 49 43.105H5C4.44772 43.105 4 42.6573 4 42.105V40.105Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1562 24.0625C40.1562 22.4056 41.4994 21.0625 43.1562 21.0625H52.1562C53.8131 21.0625 55.1562 22.4056 55.1562 24.0625V46.0625C55.1562 47.7194 53.8131 49.0625 52.1562 49.0625H43.1562C41.4994 49.0625 40.1562 47.7194 40.1562 46.0625V24.0625Z",
    fill: "url(#paint2_linear_974_10221)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1562 22.0625H43.1562C42.0517 22.0625 41.1562 22.9579 41.1562 24.0625V46.0625C41.1562 47.1671 42.0517 48.0625 43.1562 48.0625H52.1562C53.2608 48.0625 54.1562 47.1671 54.1562 46.0625V24.0625C54.1562 22.9579 53.2608 22.0625 52.1562 22.0625ZM43.1562 21.0625C41.4994 21.0625 40.1562 22.4056 40.1562 24.0625V46.0625C40.1562 47.7194 41.4994 49.0625 43.1562 49.0625H52.1562C53.8131 49.0625 55.1562 47.7194 55.1562 46.0625V24.0625C55.1562 22.4056 53.8131 21.0625 52.1562 21.0625H43.1562Z",
    fill: "#4C4C4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6562 23.0312C45.6562 22.7551 45.8801 22.5312 46.1562 22.5312H49.1562C49.4324 22.5312 49.6562 22.7551 49.6562 23.0312C49.6562 23.3074 49.4324 23.5312 49.1562 23.5312H46.1562C45.8801 23.5312 45.6562 23.3074 45.6562 23.0312Z",
    fill: "#4C4C4C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_10221",
    x1: 27.1562,
    y1: 13,
    x2: 27.1562,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDE4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_974_10221",
    x1: 27.5,
    y1: 38.0527,
    x2: 27.5,
    y2: 40.5527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_974_10221",
    x1: 47.6562,
    y1: 21.0625,
    x2: 47.6562,
    y2: 49.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAE3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboardClient);
export default __webpack_public_path__ + "static/media/icn_dashboard_client.447832488040f6cc0dfe06936a8e3199.svg";
export { ForwardRef as ReactComponent };